var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.value)?_c('div',[_c('div',{staticClass:"SBPopup"},[_c('div',{staticClass:"SBPopupInner"},[_vm._t("default")],2),_c('img',{staticClass:"SBPopupClose",attrs:{"src":require("../assets/icon_close_white.svg")}})])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }